import React from "react";
import "../styles.css";
// import arrowImg from "../components/resources/arrow_up.svg";

function BackToTop() {
    return (
        <div>
            {/* <a className="backTopLink" href="#header">
                <img src={arrowImg} alt="back_to_top" /></a> */}
        </div>
    );
};

export default BackToTop;